export * from 'server/models/InitialData';


// WEBPACK FOOTER //
// ./data/models/InitialData.ts